/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import PropTypes from 'prop-types';
import SelectBox from '@tcp/core/src/components/common/atoms/Select';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty.js';
import MiniBagSelect from '@tcp/web/src/components/features/CnC/MiniBag/molecules/MiniBagSelectBox/MiniBagSelectBox';
import Image from '@tcp/core/src/components/common/atoms/Image';

import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import DamImage from '../../../../../../common/atoms/DamImage';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/BossUnavailabelProductTile.style';

import Row from '../../../../../../common/atoms/Row';
import Col from '../../../../../../common/atoms/Col';
import {
  getAPIConfig,
  getBrand,
  getIconPath,
  getLocator,
  isMobileWeb,
  urlContainsQuery,
} from '../../../../../../../utils';
import selectBoxStyle from '../styles/SelectBox.style';
import Anchor from '../../../../../../common/atoms/Anchor';
import { getProductListToPath } from '../../../../../browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import PriceCurrency from '../../../../../../common/molecules/PriceCurrency';
import { getPrices } from '../../CartItemTile/views/CartItemTile.utils';
import BossUnavailableLabels, { CHECKOUT_LABELS } from './BossUnavailable.Labels';
import { GLOBAL_ACCESSIBILITY_LABELS } from '../../../../../../../utils/labels/globalAccessibility.labels';

const LinkWrapper = (props) => {
  LinkWrapper.propTypes = {
    pdpToPath: PropTypes.string.isRequired,
    pdpAsPathUrl: PropTypes.string.isRequired,
    disableLink: PropTypes.bool.isRequired,
    noWrap: PropTypes.bool.isRequired,
    IsSlugPathAdded: PropTypes.bool,
    children: PropTypes.node.isRequired,
  };

  LinkWrapper.defaultProps = {
    IsSlugPathAdded: false,
  };

  const { pdpToPath, pdpAsPathUrl, disableLink, children, noWrap, IsSlugPathAdded } = props;
  return noWrap ? (
    children
  ) : (
    <Anchor
      to={pdpToPath}
      asPath={pdpAsPathUrl}
      noLink={disableLink}
      IsSlugPathAdded={IsSlugPathAdded}
    >
      {children}
    </Anchor>
  );
};

const BossUnavailabelProductTile = (props) => {
  const {
    className,
    productDetails,
    isCrossBrandMerchandisingEnabled,
    cookieToken,
    currencyExchange,
    bossUnavailableListId,
    removeItemsToBossUnavailableItemAction,
    isMobileWebProductTile,
    isDesktopProductTileCleanUpDisabled,
  } = props;
  const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, BossUnavailableLabels);
  const { bagPage } = checkoutLabels;
  const getItemBrand = (itemBrand) => itemBrand && itemBrand.toUpperCase();
  const getImageConfigs = () => {
    return ['t_t_cart_item_tile_m', 't_t_cart_item_tile_t', 't_t_cart_item_tile_d'];
  };
  const {
    productInfo: { name, upc, pdpUrl, seoToken },
    skuInfo: { colorProductId, fit, size },
    itemInfo: { quantity, imagePath, itemBrand, isGiftItem },
  } = productDetails || {};

  const renderSeperator = () => {
    return <div className="color-fit-size-separator ">|</div>;
  };

  const getSeoUrl = (seotoken) => {
    const { siteId } = getAPIConfig();
    return `/${siteId}/p/${seotoken}`;
  };

  const getPdpToPath = (
    isProductBrandOfSameDomain,
    crossDomain,
    brandSpecificCrossDomain,
    brand
  ) => {
    let pdpLinkPath = pdpUrl;
    if (seoToken) {
      pdpLinkPath = getSeoUrl(seoToken);
    }

    if (isProductBrandOfSameDomain) return getProductListToPath(pdpLinkPath);
    if (isCrossBrandMerchandisingEnabled)
      return `${getProductListToPath(pdpLinkPath)}$brand=${brand.toUpperCase()}`;
    return `${brandSpecificCrossDomain[brand.toUpperCase()]}${pdpLinkPath}`;
  };

  const getPdpAsPathurl = (
    isProductBrandOfSameDomain,
    crossDomain,
    brandSpecificCrossDomain,
    brand
  ) => {
    let pdpLinkPath = pdpUrl;
    if (seoToken) {
      pdpLinkPath = getSeoUrl(seoToken);
    }
    if (isProductBrandOfSameDomain) {
      return pdpLinkPath;
    }
    if (isCrossBrandMerchandisingEnabled) return `${pdpLinkPath}$brand=${brand.toUpperCase()}`;
    if (cookieToken)
      return `${brandSpecificCrossDomain[brand.toUpperCase()]}${pdpLinkPath}${
        urlContainsQuery(pdpUrl) ? '&' : '?'
      }ct=${cookieToken}`;
    return `${brandSpecificCrossDomain[brand.toUpperCase()]}${pdpLinkPath}`;
  };

  const removeItem = () => {
    const {
      itemInfo: { itemId },
    } = productDetails;
    const payload = {
      listId: bossUnavailableListId,
      itemId,
    };
    removeItemsToBossUnavailableItemAction(payload);
  };

  const getCrossIconImage = () => {
    return (
      <Image
        role="button"
        tabIndex="0"
        className="close-icon-image"
        width={'28px'}
        height={'28px'}
        src={isMobileWebProductTile ? getIconPath('icon-remove') : getIconPath('bag-close-icon')}
        onClick={() => {
          removeItem();
        }}
      />
    );
  };

  const dropDownQuantitySelector = () => {
    const quantityArray = new Array(15).fill(1);

    const quantityList = quantityArray.map((val, index) => ({
      displayName: index + 1,
      id: index + 1,
    }));
    if (isMobileWebProductTile || !isDesktopProductTileCleanUpDisabled) {
      return (
        <div className="elem-pt-SM elem-pb-SM">
          <BodyCopy
            fontFamily="secondary"
            component="span"
            fontSize="fs12"
            fontWeight="regular"
            textAlign="left"
          >
            {`Qty ${quantity}`}
          </BodyCopy>
        </div>
      );
    }

    return (
      <div className={className}>
        <SelectBox
          customWidth="77px"
          customHeight="36px"
          downArrowBottom="17px"
          downArrowRight="8px"
          id="quantity"
          name="Quantity"
          component={MiniBagSelect}
          options={quantityList}
          // onChange={this.handleQtyChange}
          input={{ value: quantity }}
          meta
          inheritedStyles={selectBoxStyle}
          preText={`${renderLabel(bagPage.lbl_qty_text, 'lbl_qty_text')} `}
          className="quantity-ddl"
          disabled={true}
        />
      </div>
    );
  };
  const currentSiteBrandName = getBrand();
  const apiConfigObj = getAPIConfig();

  const isProductBrandOfSameDomain = currentSiteBrandName.toUpperCase() === getItemBrand(itemBrand);
  const { crossDomain, brandSpecificCrossDomain } = apiConfigObj;
  const pdpToPath = getPdpToPath(
    isProductBrandOfSameDomain,
    crossDomain,
    brandSpecificCrossDomain,
    itemBrand
  );
  const pdpAsPathUrl = getPdpAsPathurl(
    isProductBrandOfSameDomain,
    crossDomain,
    brandSpecificCrossDomain,
    itemBrand
  );
  const { price, wasPrice } = getPrices({
    productDetail: productDetails,
    currencyExchange,
  });
  return (
    <div className={`${className} boss-unavailable-tile-container`}>
      <div className="product-tile-container">
        <div className={'crossDeleteIconBag'}>{getCrossIconImage()}</div>
        <Row className={'product product-tile-wrapper'} fullBleed>
          <Col
            key="productDetails"
            className={`align-product-img product-brand-img-wrapper`}
            colSize={{ small: 2, medium: 2, large: 3 }}
          >
            <div className="imageWrapper">
              <LinkWrapper
                pdpToPath={pdpToPath}
                pdpAsPathUrl={pdpAsPathUrl}
                disableLink={false}
                noWrap={false}
                IsSlugPathAdded
              >
                <DamImage
                  imgData={{
                    alt: `${'test'} ${name}`,
                    url: imagePath,
                  }}
                  imgConfigs={getImageConfigs()}
                  itemBrand={getItemBrand(itemBrand)}
                  isProductImage
                  className={`${'dam-image-HW '}`}
                />
              </LinkWrapper>
            </div>
            {!isGiftItem && (
              <div className="logoWrapper">
                <Image
                  alt={getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_ACCESSIBILITY_LABELS}.lbl_brandlogo_${itemBrand
                      ?.toString()
                      ?.toLowerCase()}AltText`
                  )}
                  className="brand-image"
                  src={getIconPath(`header__brand-tab-${itemBrand?.toString()?.toLowerCase()}`)}
                  data-locator={getLocator('cart_item_brand_logo')}
                />
              </div>
            )}
          </Col>

          <Col
            className="bag-product-detail-wrapper"
            key="productDetails"
            colSize={{ small: 4, medium: 6, large: 9 }}
          >
            <Row className="product-detail-row">
              <Col className="productImgBrand" colSize={{ small: 4, medium: 6, large: 12 }}>
                <div
                  className={`hide-on-desktop hide-on-tablet ${
                    !isMobileWebProductTile && 'hide-on-mobile'
                  }`}
                >
                  <BodyCopy
                    fontFamily="secondary"
                    component="div"
                    fontSize="fs14"
                    fontWeight="regular"
                    className="price-tag"
                    dataLocator={getLocator('cart_item_title')}
                  >
                    <PriceCurrency price={Number(price)} />
                  </BodyCopy>
                  {wasPrice > 0 && (
                    <BodyCopy
                      fontFamily="secondary"
                      component="div"
                      fontSize="fs14"
                      fontWeight="regular"
                      className="was-price-tag"
                      dataLocator={getLocator('cart_item_title')}
                    >
                      <PriceCurrency price={Number(wasPrice)} />
                    </BodyCopy>
                  )}
                </div>
                <LinkWrapper
                  pdpToPath={pdpToPath}
                  pdpAsPathUrl={pdpAsPathUrl}
                  disableLink={false}
                  noWrap={false}
                  IsSlugPathAdded
                >
                  <BodyCopy
                    fontFamily="secondary"
                    component="span"
                    fontSize={isMobileWeb() ? 'fs14' : 'fs16'}
                    fontWeight="bold"
                    dataLocator={getLocator('cart_item_title')}
                    className={'product-name-tag'}
                  >
                    {name}
                  </BodyCopy>
                </LinkWrapper>
              </Col>
              <BodyCopy
                fontFamily="secondary"
                component="div"
                fontSize={isDesktopProductTileCleanUpDisabled ? 'fs10' : 'fs12'}
                color="gray.600"
                fontWeight="semiBold"
                textAlign="right"
                className="upc-container"
                dataLocator={getLocator('cart_item_upc')}
              >
                {`UPC: ${upc}`}
              </BodyCopy>
            </Row>
            <Row className="product-detail-row color-map-size-fit">
              <Col
                className="productImgBrand elem-mt-SM"
                colSize={{ small: 4, medium: 6, large: 12 }}
              >
                <div className="attribute-container">
                  <div className="attribute-section">
                    <BodyCopy
                      fontFamily="secondary"
                      component="span"
                      fontSize="fs14"
                      fontWeight="regular"
                      dataLocator={getLocator('cart_item_title')}
                      className="size-fit-text text-capitalize"
                    >
                      {colorProductId?.toLowerCase()}
                    </BodyCopy>
                    {colorProductId && renderSeperator()}
                    <BodyCopy
                      fontFamily="secondary"
                      component="span"
                      fontSize="fs14"
                      fontWeight="regular"
                      dataLocator={getLocator('cart_item_title')}
                      className={'size-fit-text'}
                    >
                      {`${size} ${fit || ''}`}
                    </BodyCopy>

                    {!isDesktopProductTileCleanUpDisabled && (
                      <>
                        {quantity && renderSeperator()}

                        <BodyCopy
                          fontFamily="secondary"
                          component="span"
                          fontSize="fs14"
                          fontWeight="regular"
                          textAlign="left"
                        >
                          {`Qty ${quantity}`}
                        </BodyCopy>
                      </>
                    )}
                  </div>
                  {!isDesktopProductTileCleanUpDisabled && (
                    <div className="price-section">
                      <BodyCopy
                        fontFamily="secondary"
                        component="div"
                        fontSize="fs20"
                        fontWeight="regular"
                        className="price-tag"
                        dataLocator={getLocator('cart_item_title')}
                      >
                        <PriceCurrency price={Number(price)} />
                      </BodyCopy>
                      {wasPrice > 0 && (
                        <BodyCopy
                          fontFamily="secondary"
                          component="div"
                          fontSize="fs12"
                          fontWeight="regular"
                          className="was-price-tag"
                          dataLocator={getLocator('cart_item_title')}
                        >
                          <PriceCurrency price={Number(wasPrice)} />
                        </BodyCopy>
                      )}
                    </div>
                  )}
                </div>
                {isDesktopProductTileCleanUpDisabled && (
                  <div className="price-qty-container">
                    {dropDownQuantitySelector()}
                    <div className={`${isMobileWebProductTile ? 'hide-on-mobile' : ''}`}>
                      <BodyCopy
                        fontFamily="secondary"
                        component="div"
                        fontSize="fs16"
                        fontWeight="regular"
                        className="price-tag"
                        dataLocator={getLocator('cart_item_title')}
                      >
                        <PriceCurrency price={Number(price)} />
                      </BodyCopy>
                      {wasPrice > 0 && (
                        <BodyCopy
                          fontFamily="secondary"
                          component="div"
                          fontSize="fs14"
                          fontWeight="regular"
                          className="was-price-tag"
                          dataLocator={getLocator('cart_item_title')}
                        >
                          <PriceCurrency price={Number(wasPrice)} />
                        </BodyCopy>
                      )}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default withStyles(BossUnavailabelProductTile, styles);
